<template>
    <div class="editor" v-if="editor">
        <EditorMenuBar class="editor__header" :editor="editor" />
        <editor-content class="editor__content" :editor="editor" />
    </div>
</template>

<script>
import EditorMenuBar from "@/component/common/editor/EditorMenuBar.vue";
import {Editor, EditorContent} from "@tiptap/vue-2";
import StarterKit from "@tiptap/starter-kit";

export default {
    name: "Editor",
    components: {
        EditorMenuBar,
        EditorContent
    },
    data() {
        return {
            editor: null
        }
    },
    mounted() {
        this.editor = new Editor({
            content: '<p>Sadrzaj....</p>',
            extensions: [
                StarterKit,
            ],
        })
    },
    beforeDestroy() {
        this.editor.destroy()
    },
}
</script>

<style scoped>
.editor {
    background-color: #fff;
    border: 1px solid #0d0d0d;
    color: #0d0d0d;
    display: flex;
    flex-direction: column;
    max-height: 26rem;
    margin-bottom: 20px;
    /* Some information about the status */
}
.ProseMirror ul, li {

}
.editor__header {
    align-items: center;
    background: #0d0d0d;
    border-bottom: 3px solid #0d0d0d;
    display: flex;
    flex: 0 0 auto;
    flex-wrap: wrap;
    padding: 0.25rem;
}
.editor__content {
    flex: 1 1 auto;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 1.25rem 1rem;
    outline: none !important;
    -webkit-overflow-scrolling: touch;
}
.editor__content :focus-visible {
    outline: none !important;
}
.editor__name button {
    background: none;
    border: none;
    border-radius: 0.4rem;
    color: #0d0d0d;
    font: inherit;
    font-size: 12px;
    font-weight: 600;
    padding: 0.25rem 0.5rem;
}
.editor__name button:hover {
    background-color: #0d0d0d;
    color: #fff;
}
/* Basic editor styles */
.ProseMirror > * + * {
    margin-top: 0.75em;
}
.ProseMirror ul, .ProseMirror ol {
    padding: 0 1rem;
}
.ProseMirror h1, .ProseMirror h2, .ProseMirror h3, .ProseMirror h4, .ProseMirror h5, .ProseMirror h6 {
    line-height: 1.1;
}
.ProseMirror code {
    background-color: rgba(97, 97, 97, 0.1);
    color: #616161;
}
.ProseMirror pre {
    background: #0d0d0d;
    border-radius: 0.5rem;
    color: #fff;
    font-family: 'JetBrainsMono', monospace;
    padding: 0.75rem 1rem;
}
.ProseMirror pre code {
    background: none;
    color: inherit;
    font-size: 0.8rem;
    padding: 0;
}
.ProseMirror mark {
    background-color: #faf594;
}
.ProseMirror img {
    height: auto;
    max-width: 100%;
}
.ProseMirror hr {
    margin: 1rem 0;
}
.ProseMirror blockquote {
    border-left: 2px solid rgba(13, 13, 13, 0.1);
    padding-left: 1rem;
}
.ProseMirror hr {
    border: none;
    border-top: 2px solid rgba(13, 13, 13, 0.1);
    margin: 2rem 0;
}
.ProseMirror ul[data-type="taskList"] {
    list-style: none;
    padding: 0;
}
.ProseMirror ul[data-type="taskList"] li {
    align-items: center;
    display: flex;
}
.ProseMirror ul[data-type="taskList"] li > label {
    flex: 0 0 auto;
    margin-right: 0.5rem;
    user-select: none;
}
.ProseMirror ul[data-type="taskList"] li > div {
    flex: 1 1 auto;
}
</style>